export const onWhatsAppClick = (phoneNumber: string) => {
  const url = `https://wa.me/${phoneNumber}`;
  window.open(url, '_blank');
};
